import { useState } from "react";
import { withNamespaces } from "react-i18next";
import DecisionModal from "./DecisionModal";
import { Button, UncontrolledTooltip } from "reactstrap";
import { RiThumbDownLine, RiThumbUpLine } from "react-icons/ri";
import { useMutation } from "@tanstack/react-query";
import ComplianceMonitoringService from "src/modules/3rd-party-management/apis/admin/compliance/monitoring/MonitoringService";
import { toast } from "react-toastify";
import ComplianceScreeningService from "src/modules/3rd-party-management/apis/admin/compliance/screening/ScreeningService";

const RelevancyActions = ({ 
    t, 
    complianceType, // 'monitoring' | 'screening'
    id,
    isFalsePositive: defaultFalsePositiveStatus
}) => {
    const [isFalsePositive, setIsFalsePositive] = useState(defaultFalsePositiveStatus);
    const [decisionModalOpen, setDecisionModalOpen] = useState(false);
    const [decisionActionType, setDecisionActionType] = useState(null);

    const openDecisionModal = (type) => {
        setDecisionActionType(type);
        setDecisionModalOpen(true);
    };

    const handleUpdateFalsePositive = useMutation({
        mutationFn: async (payload) => {
            if (complianceType === 'screening') {
                return await (ComplianceScreeningService.getInstance()).updateResultFalsePositive(payload);
            }

            return await (ComplianceMonitoringService.getInstance()).updateAlertFalsePositive(payload);
        },
        onSuccess: ({ data }) => {
            setIsFalsePositive(data.is_false_positive);

            toast(t("Relevancy updated successfully."), {
                type: "success"
            });
        },
        onError: () => {
            toast(t("An error occurred while updating relevancy."), {
                type: "error"
            });
        },
        onSettled: () => {
            setDecisionModalOpen(false);
        }
    });

    return (
        <div className="d-flex gap-2">
            <Button
                id="relavant-result-btn"
                onClick={() => openDecisionModal('relevant')}
                outline={isFalsePositive === undefined || isFalsePositive === true}
                color="danger"
            >
                <RiThumbUpLine size="20" />

                <UncontrolledTooltip
                    target="relavant-result-btn"
                >
                    {t('Mark this result as a valid match requiring further action.')}
                </UncontrolledTooltip>
            </Button>

            <Button
                id="false-positive-btn"
                onClick={() => openDecisionModal('false_positive')}
                outline={isFalsePositive === undefined || isFalsePositive === false}
                color="success"
            >
                <RiThumbDownLine size="20" />

                <UncontrolledTooltip
                    target="false-positive-btn"
                >
                    {t('Mark this result as not matching the entity.')}
                </UncontrolledTooltip>
            </Button>

            <DecisionModal
                isOpen={decisionModalOpen}
                toggle={() => setDecisionModalOpen(!decisionModalOpen)}
                type={decisionActionType}
                onConfirm={() => {
                    if (complianceType === 'monitoring') {
                        handleUpdateFalsePositive.mutate({
                            alert_id: id,
                            is_false_positive: decisionActionType === 'false_positive'
                        });
                    }
                    else {
                        handleUpdateFalsePositive.mutate({
                            result_id: id,
                            is_false_positive: decisionActionType === 'false_positive'
                        });
                    }
                }}
                loading={handleUpdateFalsePositive.isLoading}
            />
        </div>
    )
}

export default withNamespaces()(
    RelevancyActions
);